import { ShieldCheck, Footprints, BadgeCheck } from "lucide-react";

export const Verification = () => (
  <section data-testid="verification" className="nb-section">
    <div className="nb-shell">
      <p className="nb-eyebrow">Verification</p>
      <h2 className="nb-h2 mt-4 max-w-[24ch]">Why we're slow about letting bays in</h2>
      <p className="nb-sub mt-6 max-w-[68ch]">
        Anyone can put a photo of a driveway on the internet. That's exactly the problem we're
        solving, so verification isn't a formality here — it's the product.
      </p>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        <div data-testid="verification-small" className="nb-card border-l-2 border-l-brand">
          <ShieldCheck size={20} className="text-ok" aria-hidden="true" />
          <h3 className="mt-3 text-base">1 to 4 bays at one address</h3>
          <p className="mt-2 text-sm text-ink2">
            We call the host and speak to them, match the photo to the address, and confirm the gate
            rules and the night hours before the bay is published.
          </p>
        </div>
        <div data-testid="verification-large" className="nb-card border-l-2 border-l-brand">
          <Footprints size={20} className="text-ok" aria-hidden="true" />
          <h3 className="mt-3 text-base">5 or more bays at one address</h3>
          <p className="mt-2 text-sm text-ink2">
            Everything above, <strong className="text-ink">plus a NightBay team member physically
            visits the site</strong>, sees the bays, meets the guard or the facility manager, and logs
            the visit. The listing stays pending until that visit is recorded. There is no way to
            skip it, even for us.
          </p>
        </div>
      </div>

      <p className="mt-8 flex items-start gap-3 text-sm text-ink3">
        <BadgeCheck size={18} className="mt-0.5 shrink-0 text-ok" aria-hidden="true" />
        Renters are verified too: every account is a verified Indian mobile number, and hosts see the
        renter's name and verification status before they accept.
      </p>
    </div>
  </section>
);
